

































































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component} from '@/shared/component';
import {AbstractEditVue} from '@/components/Abstract/AbstractEditVue';
import {Projet} from '@/models';

import storeProjet from '@/stores/modules/projet';

import InputPhone from '@/components/Input/Phone.vue';
import InputCountry from "@/components/Input/Country.vue";
import InputZipCode from "@/components/Input/ZipCode.vue";

import storeClient from "@/stores/modules/client"

@Component({
	components: {
		InputPhone,
		InputCountry,
		InputZipCode,
	}
})
export default class CrudProjetEdit extends AbstractEditVue<Projet> {

	// DF: utiliser pour la création d'un projet uniquement
	// en modification on passe par la light
	private step: number = 1;
	private storeClient = storeClient;

	public constructor() {
		super(
			storeProjet,
			'Projet modifié',
			'Projet créé',
		);
	}

	protected async onSubmit(): Promise<void> {
		super.onSubmit();
		this.step = 1;
	}

	public async mounted(): Promise<void> {
		await storeClient.dispatch('getAll');
		await super.mounted();
	}

	public async refresh(): Promise<void> {
		await super.refresh();
		//console.log('route projet edit = ' + this.$route.name);
		if (this.$route.name === 'projet-edit') {
			this.$route.meta.title = 'Modification  d\'un projet';
		}
	}

}
